<template>
  <div style="background-color: #EFEFEF">
    <!--    <div class="news-banner">-->
    <!--      <div class="news-banner-title">-->
    <!--        <div class="news-banner-title-en">NEWS</div>-->
    <!--        <div class="news-banner-title-zh">新闻中心</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <banner />
    <div class="news-nav" id="news-nav">
      <div class="news-nav-pre cus-pointer" @click="jump('/')">
        首页
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/news')">
        新闻中心
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-current">
        {{ newsDetail.type }}
      </div>
    </div>
    <div class="news-box">
      <div class="news-detail">
        <div class="news-detail-title">
          <div class="news-detail-title-first">
            {{ newsDetail.title }}
          </div>
          <div class="news-detail-title-second">
            <div class="news-detail-title-second-author">
              <img
                style="width: 0.72rem"
                src="../../assets/image/news/news-author.png"
              />
            </div>
            <div class="news-detail-title-second-date">
              {{ newsDetail.time }}
            </div>
          </div>
        </div>
        <div
          style="background-color: #999999;border: 0.01rem solid #999999;margin: 0 0.38rem 0.4rem 0.38rem"
        ></div>
        <div style="display: flex;justify-content: center;padding: 0 0.38rem;">
          <div style="line-height: 0.35rem;font-size: 0.16rem" v-html="newsDetail.detail"></div>
        </div>
        <div
          style="background-color: #999999;border: 0.01rem solid #999999;margin: 0 0.38rem 0.4rem 0.38rem"
        ></div>
        <div class="news-detail-footer">
          <div
            @click="preOrNext(-1)"
            v-if="showPreNews"
            class="news-prev cus-pointer"
          >
            <img src="../../assets/image/news/jt_left.png" />上一篇
          </div>
          <div v-else style="visibility: hidden" class="news-prev cus-pointer">
            <img src="../../assets/image/news/jt_left.png" />上一篇
          </div>
          <div class="news-back-list cus-pointer background-fill" @click="goBack">返回列表</div>
          <div
            @click="preOrNext(1)"
            v-if="showNextNews"
            class="news-next cus-pointer"
          >
            下一篇<img src="../../assets/image/news/jt_right.png" />
          </div>
          <div v-else style="visibility: hidden" class="news-next cus-pointer">
            下一篇<img src="../../assets/image/news/jt_right.png" />
          </div>
        </div>
      </div>
      <div class="news-more">
        <div class="news-more-title">更多新闻推荐</div>
        <div
          class="news-more-item cus-pointer"
          v-for="(item, index) in hotNews"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="news-more-item-img">
            <img
              style="width: 1.02rem;height: 0.72rem"
              :src="require(`@/assets/${item.imageSrc}`)"
            />
          </div>
          <div class="news-more-item-right">
            <div
              style="font-size: 0.14rem;font-weight: 400;color: #333333;width: 2.18rem"
            >
              {{ item.title }}
            </div>
            <div style="font-size: 0.12rem;font-weight: 400;color: #999999;">
              {{ item.time }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "./components/banner";
import newsData from "./newsData";
import {backItem} from "../../util/util";

export default {
  name: "newsDetail",
  components: {
    banner
  },
  data() {
    return {
      showPreNews: true,
      showNextNews: true,
      newsDetail: null,
      hotNews: [],
      h:
        '<p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;font-size: 14px;color: rgb(25, 25, 25);font-family: 宋体;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important">&nbsp; &nbsp; &nbsp;&nbsp;7月14日，根据中华人民共和国工业和信息化部下发的《关于深圳市第五批专精特新“小巨人”企业和第二批专精特新“小巨人”复核通过企业名单的公示》，<strong style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;visibility: visible">深圳市网联天下科技有限公司（简称“网联天下”）被认定为第五批国家级专精特新“小巨人”企业。</strong></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;text-align: center;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><img class="rich_pages wxw-img" src="https://mmbiz.qpic.cn/sz_mmbiz_png/a8l3eVicpSowrvjnPIZKAWlgGzmHUQG8WT0abKYNm0zQRr8rHteXQhXTecFawMCwbCR0RyUd03aiaibkAKnwWTUgA/640?wx_fmt=png&wxfrom=5&wx_lazy=1&wx_co=1" alt="图片"/></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;text-align: center;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><img class="rich_pages wxw-img" src="https://mmbiz.qpic.cn/sz_mmbiz_png/a8l3eVicpSowrvjnPIZKAWlgGzmHUQG8WN7ibgzSM28NvqCwtiaHHjtHzbbAyd9HtmGtRhhar0D4vUeKOkZBQ2rAQ/640?wx_fmt=png&wxfrom=5&wx_lazy=1&wx_co=1" alt="图片"/></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px;visibility: visible"><span style=";padding: 0px;outline: 0px;max-width: 100%;color: rgb(25, 25, 25);font-family: 宋体;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important">&nbsp; &nbsp; &nbsp;&nbsp;</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;color: rgb(25, 25, 25);font-family: 宋体;letter-spacing: 0.034em;visibility: visible">专精特新“小巨人”企业是专精特新中小企业中的突出者，企业认定需同时满足专、精、特、新、链、品六个方面指标，<strong style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;visibility: visible">是专注于产业细分市场、创新能力强、市场占有率高、掌握产业链关键环节核心技术、质量效益优的排头兵企业。</strong>专精特新“小巨人”企业是中小企业评定工作中最高等级、最具权威的荣誉称号。</span></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px;visibility: visible"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">&nbsp; &nbsp; &nbsp; &nbsp;网联天下是深圳市柠檬网联科技股份有限公司（以下简称“柠檬网联”）的全资子公司，聚焦于中职、高校校园和工业园区场景，历经十年发展，</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;visibility: visible"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">推出了一系列接入网关、网络控制器、接入交换机、光线路终端</span>(OLT)<span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">、无线接入点等</span></span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible"><span style=";padding: 0px;outline: 0px;max-width: 100%;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important">从</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;visibility: visible">WiFi5</span><span style=";padding: 0px;outline: 0px;max-width: 100%;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important">、</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;visibility: visible">WiFi</span></span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;visibility: visible">6</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">到光网的全系列通信产品，</span><strong style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;visibility: visible"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">具备园区场景整套的以太网和全光网的成熟组网方案，</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">具备实现终端到平台、平台到应用的产业链全栈式产品方案能力，持续推动</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">无线园区</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;visibility: visible">和千兆光网的落地应用。</span></strong></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;text-align: center;visibility: visible;box-sizing: border-box !important;overflow-wrap: break-word !important"><img class="rich_pages wxw-img" src="https://mmbiz.qpic.cn/sz_mmbiz_png/a8l3eVicpSowrvjnPIZKAWlgGzmHUQG8WKDgcKjLgrvB3unLfsfSD3fxI56bjNqvuZoIvBvrcVghzQvhMV4RyvA/640?wx_fmt=png&wxfrom=5&wx_lazy=1&wx_co=1" alt="图片"/></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px;font-family: 宋体">&nbsp; &nbsp; &nbsp; &nbsp;网联天下是国家高新技术企业、国家科技型中小企业；公司注重知识产权的保护，目前已<span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">拥有56</span>余项知识产权；导入了质量管理体系、环境管理体系、信息安全管理体系、信息技术服务管理体系、中国职业健康安全管理体系、五星级商品售后服务等体系并取得了相关认证；<span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">继获得深圳市“专精特新”中小企业称号之后，获评国家级专精特新“小巨人”企业，是对柠檬网联在精耕市场、产品能力、技术实力、创新能力等方面的再一次认可与肯定。</span></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">&nbsp; &nbsp; &nbsp; &nbsp;柠檬网联目前拥有全国30个分支机构，项目覆盖25个省份</span>200<span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">多个地市。</span></span><strong style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">公司以规划、设计、投资、建设、运营、维护六位一体的运营模式，为全国近2</span>000家客户数千万用户提供无线网络服务。</span></strong><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">工业企业客户涵盖如比亚迪、</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">富士康、昌硕、立讯、</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">伯恩光学、欣旺达、</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri">TCL</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important">、京东方、海尔、长城等国内知名大厂，校园客户包括中职、高职、本科院校数百</span>所，成为中国领先的厂园无线网络解决方案及运营商，</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">细分市场的龙头企业。</span></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">&nbsp; &nbsp; &nbsp; &nbsp;在国家网络强国、数字中国的政策指引下，随着工业企业和中等、高等教育院校对无线网络、智慧园区、数字园区需求的增加和升级，柠檬网联将不断深耕细分市场，在</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">网络硬件平台的基础上融合物联网、大数据、云计算、人工智能等新一代信息技术打造数字园区的产品和整体解决方案</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">，</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">持续助力</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">校园和</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">工业园区的数字化转型升级，</span><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体">让每个校园和厂园用户都用上高品质的无线网络，连接美好世界，畅享智慧生活。</span></span></p><p style="margin-top: 0px;margin-bottom: 24px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;text-align: center;box-sizing: border-box !important;overflow-wrap: break-word !important"><img class="rich_pages wxw-img" src="https://mmbiz.qpic.cn/sz_mmbiz_png/a8l3eVicpSowrvjnPIZKAWlgGzmHUQG8WPQONhpUKNBzibKlHZllCaQODRS4OnZKfysEiaNU7eFAffBuNKHa0NONA/640?wx_fmt=png&wxfrom=5&wx_lazy=1&wx_co=1" alt="图片"/></p><p style="margin-top: 0px;margin-bottom: 0px;padding: 0px;outline: 0px;max-width: 100%;clear: both;min-height: 1em;text-align: right;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 14px"><span style=";padding: 0px;outline: 0px;max-width: 100%;color: rgb(26, 27, 28);font-family: -apple-system, system-ui, BlinkMacSystemFont, &#39;PingFang SC&#39;, &#39;SF Pro Text&#39;, &#39;Helvetica Neue&#39;, Helvetica, &#39;Hiragino Sans GB&#39;, &#39;Heiti SC&#39;, Arial, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, sans-serif;letter-spacing: normal;text-align: start;box-sizing: border-box !important;overflow-wrap: break-word !important">中国厂园无线网络解决方案及运营商</span><br/><span style=";padding: 0px;outline: 0px;max-width: 100%;color: rgb(26, 27, 28);font-family: -apple-system, system-ui, BlinkMacSystemFont, &#39;PingFang SC&#39;, &#39;SF Pro Text&#39;, &#39;Helvetica Neue&#39;, Helvetica, &#39;Hiragino Sans GB&#39;, &#39;Heiti SC&#39;, Arial, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, sans-serif;letter-spacing: normal;text-align: start;box-sizing: border-box !important;overflow-wrap: break-word !important">中国数智园区解决方案及运营商</span><br/><span style=";padding: 0px;outline: 0px;max-width: 100%;color: rgb(26, 27, 28);font-family: -apple-system, system-ui, BlinkMacSystemFont, &#39;PingFang SC&#39;, &#39;SF Pro Text&#39;, &#39;Helvetica Neue&#39;, Helvetica, &#39;Hiragino Sans GB&#39;, &#39;Heiti SC&#39;, Arial, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, sans-serif;letter-spacing: normal;text-align: start;box-sizing: border-box !important;overflow-wrap: break-word !important">柠檬网联</span></span></p><p><br/></p>'
    };
  },
  //为啥这里进来不是每次执行，在另外一个界面又是每次执行呢？
  // y:路由配置里面，不是每一项都要配置keepAlive:true的，默认不用去配置，当组件需要被缓存时再去配置
  created() {
    let id = this.$route.query.id === undefined ? "1" : this.$route.query.id;
    this.handleData(id);
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.handleData(newVal);
    }
  },
  methods: {
    handleData(id) {
      this.newsDetail = newsData.filter(v => id == v.id)[0];
      this.hotNews = newsData.slice(0, 5);
      this.showPreNews = parseInt(id) > 1;
      this.showNextNews = parseInt(id) < 14;
    },
    handleDetail(id) {
      this.handleData(id);
      backItem("news-nav");
    },
    jump(r) {
      this.$router.push({ path: r });
    },
    goBack() {
      this.$router.go(-1);
    },
    preOrNext(step) {
      this.handleDetail(parseInt(this.newsDetail.id) + step);
      backItem("news-nav");
    },
    // backTop() {
    //   const element = document.getElementById("news-nav");
    //   if (element) {
    //     element.scrollIntoView({ behavior: "smooth" });
    //   }
    // }
  }
};
</script>

<style scoped>
.news-box {
  padding: 0.8rem 2.18rem 1.31rem 2.18rem;
  display: flex;
  align-items: self-start;
}
.news-detail {
  width: 10.2rem;
  margin-right: 0.4rem;
  background-color: #ffffff;
}
.news-nav {
  padding: 0.29rem 0 0.29rem 2.18rem;
  background: #ffffff;
  display: flex;
  align-items: center;
}
.news-more {
  width: 4.24rem;
  padding: 0.4rem;
  background-color: #ffffff;
}
.news-detail-title {
  padding: 0.4rem 1.2rem;
}
.news-detail-title-first {
  font-size: 0.32rem;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.2rem;
  text-align: start;
}
.news-detail-title-second {
  display: flex;
}
.news-detail-title-second-date {
  font-weight: 400;
  font-size: 0.14rem;
  color: #3b5377;
}
.news-detail-title-second-author {
  margin-right: 0.4rem;
}
.news-more-title {
  font-size: 0.22rem;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.4rem;
}
.news-more-item {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.2rem;
  border-bottom: 0.01rem solid #999999;
  margin-top: 0.2rem;
}
.news-more-item:last-child {
  border-bottom: 0;
}
.news-more-item:first-child {
  margin-top: 0;
}
.news-more-item-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.news-detail-footer {
  padding: 0 0.4rem 0.5rem 0.4rem;
  display: flex;
  justify-content: space-between;
}
.news-prev,
.news-next {
  display: flex;
  align-items: center;
}
.news-prev > img,
.news-next > img,
.news-nav > img {
  width: 0.06rem;
  height: 0.12rem;
}
.news-nav > img {
  margin: 0 0.2rem;
}
.news-prev > img {
  margin-right: 0.1rem;
}
.news-next > img {
  margin-left: 0.1rem;
}
.news-back-list {
  width: 1.4rem;
  height: 0.42rem;
  background-image: url("../../assets/image/solution/solution-four-more.png");
  background-size: 100% 100%; /* 背景图片自适应容器大小 */
  background-repeat: no-repeat; /* 防止背景图片重复 */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
.news-back-list:hover{
  clip-path: polygon(0 0, calc(100% - 0.08rem) 0%, 100% 0.08rem, 100% 100%, 0.08rem 100%, 0% calc(100% - 0.08rem));
}
.news-banner {
  width: 100%;
  height: 5.8rem;
  background-image: url("../../assets/image/news/banbg.png");
  background-size: cover; /* 调整背景图片大小以填充div */
  background-position: center; /* 居中显示背景图片 */
}
.news-banner-title-en {
  font-size: 0.44rem;
  font-weight: 500;
  color: #ffffff;
  text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
  opacity: 0.5;
  margin-left: 0.2rem;
}
.news-banner-title {
  padding-top: 2.75rem;
  padding-left: 2.18rem;
}
.news-banner-title-zh {
  font-size: 0.44rem;
  font-weight: 500;
  color: #ffffff;
  text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
  margin-top: -0.38rem;
}
.news-nav-pre {
  font-size: 0.16rem;
  font-weight: 400;
  color: #999999;
}
.news-nav-current {
  height: 0.22rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/newsDetail.vue